var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.instances),function(instance,i){return _c('Instance',{key:instance._id,attrs:{"instance":instance,"instanceIndex":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }